import { useMutation, useQuery } from '@tanstack/react-query';

import { Page } from '../../common/contracts';
import { EQueryKeys } from '../../constants/enums';
import useAxios from '../../hooks/useAxios';
import { EApiRoutes, fetchConfig, getApiRouteOrMock } from '../api.utils';
import { useParams } from 'react-router';

export function usePages(pageId?: string) {
  const axios = useAxios();
  const { portalId } = useParams();
  const customHeaders = portalId ? { 'x-portal': portalId } : undefined;

  const getPages = useQuery({
    ...fetchConfig.list,
    queryKey: [EQueryKeys.PAGES],
    queryFn: async () => {
      return await axios.get(
        getApiRouteOrMock(EApiRoutes.PAGES),
        {},
        customHeaders
      );
    }
  });

  const getPage = useQuery({
    ...fetchConfig.single,
    queryKey: [`${EQueryKeys.PAGES}_${pageId}`],
    queryFn: async () => {
      return await axios.get(
        `${getApiRouteOrMock(EApiRoutes.PAGES)}/${pageId}`,
        {},
        customHeaders
      );
    },
    enabled: !!pageId
  });

  const addPage = useMutation(async (newPage: Page) => {
    return await axios.post(
      getApiRouteOrMock(EApiRoutes.PAGES),
      newPage,
      customHeaders
    );
  }, {});

  const deletePage = useMutation(async (pageIdToDelete: string) => {
    return await axios.del(
      `${getApiRouteOrMock(EApiRoutes.PAGES)}/${pageIdToDelete}`,
        {},
        customHeaders
    );
  }, {});

  const updatePage = useMutation(
    async ({ form, pageId }: { form: Partial<Page>; pageId: string }) => {
      return axios.put(
        `${getApiRouteOrMock(EApiRoutes.PAGES)}/${pageId}`,
        form,
        customHeaders
      );
    },
    {}
  );

  return {
    getPages,
    getPage,
    addPage,
    deletePage,
    updatePage
  };
}
